import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PdfBlockReasonCode } from '../models/pdf-analysis-result.model';

export interface PdfInspectorErrorModalData {
  reasonCode: PdfBlockReasonCode;
}

interface PdfInspectorErrorModalCopy {
  titleKey: string;
  subtitleKey: string;
}

// Copy por PdfBlockReasonCode. 'corrupted' y 'empty' comparten el mismo mensaje ("No pudimos leer
// el PDF") por decisión de producto (ver ECM-13965). 'unknown' es el fallback para cualquier
// `detail` no reconocido del backend.
const PDF_INSPECTOR_ERROR_COPY: Record<PdfBlockReasonCode, PdfInspectorErrorModalCopy> = {
  corrupted: {
    titleKey: 'pdfInspector.errorModal.corrupted.title',
    subtitleKey: 'pdfInspector.errorModal.corrupted.subtitle'
  },
  empty: {
    titleKey: 'pdfInspector.errorModal.corrupted.title',
    subtitleKey: 'pdfInspector.errorModal.corrupted.subtitle'
  },
  password: {
    titleKey: 'pdfInspector.errorModal.password.title',
    subtitleKey: 'pdfInspector.errorModal.password.subtitle'
  },
  blocked: {
    titleKey: 'pdfInspector.errorModal.blocked.title',
    subtitleKey: 'pdfInspector.errorModal.blocked.subtitle'
  },
  unknown: {
    titleKey: 'pdfInspector.errorModal.blocked.title',
    subtitleKey: 'pdfInspector.errorModal.blocked.subtitle'
  }
};

@Component({
  standalone: false,
  selector: 'app-pdf-inspector-error-modal',
  templateUrl: './pdf-inspector-error-modal.component.html',
  styles: []
})
export class PdfInspectorErrorModalComponent {
  readonly titleKey: string;
  readonly subtitleKey: string;

  constructor(
    private dialogRef: MatDialogRef<PdfInspectorErrorModalComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) data: PdfInspectorErrorModalData
  ) {
    const copy = PDF_INSPECTOR_ERROR_COPY[data?.reasonCode] ?? PDF_INSPECTOR_ERROR_COPY.unknown;
    this.titleKey = copy.titleKey;
    this.subtitleKey = copy.subtitleKey;
  }

  retry(): void {
    this.dialogRef.close(true);
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
